<template>
  <div>
    <!-- <el-button type="primary" icon="el-icon-plus" size="mini" circle @click="addGoods" style="float:right;margin:10px 15px 10px 0;"></el-button> -->
    <el-table
      ref="list"
      border
      :data="tableData"
      style="width: 100%"
      @row-click="rowClick"
      show-summary
      :summary-method="getSummaries"
    >
      <el-table-column
        type="index"
        label="序号"
        width="50"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="GoodsCode"
        label="条码"
        min-width="150px"
        show-overflow-tooltip
      />
      <el-table-column label="商品名称" min-width="150px" prop="GoodsName">
        <template slot-scope="{ row }">
          <account-select
            v-model="row.GoodsName"
            :source="DAccount"
            @select="onSelect($event, row)"
            :pageSize="pageParams.pageSize"
            :pageIndex="pageParams.pageIndex"
            :listTotal="listTotal"
            @currentPage="currentPage($event, row)"
            @click.native="resetFun"
            @inputText="inputText($event, row)"
            :pageType="true"
          />
        </template>
      </el-table-column>
      <el-table-column prop="Model" label="规格型号" />
      <el-table-column prop="MainUnitName" label="单位" />
      <el-table-column prop="Quantity" label="数量">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.Quantity"
            type="number"
            @blur="onBlur(row, 'Quantity')"
            @focus="onFocus(row, 'Quantity')"
            @input="changeNum(row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="Price" label="单价">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.Price"
            type="number"
            @blur="onBlur(row, 'Price')"
            @focus="onFocus(row, 'Price')"
            @input="changeNum(row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="Amount" label="金额" />
      <el-table-column prop="ExistQuantity" label="现存量" />
      <el-table-column label="备注" prop="Remark">
        <template slot-scope="{ row }">
          <el-input v-model="row.Remark" placeholder="请输入备注" @change="editT(row)" min-width="200px"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="130px">
        <template slot-scope="scope">
          <el-link
            icon="el-icon-copy-document"
            style="margin-right: 10px"
            @click="copy(scope.row, scope.$index)"
            :underline="false"
            >复制</el-link
          >
          <el-link
            icon="el-icon-delete"
            @click="del(scope.row, scope.$index)"
            :underline="false"
            >删除</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-divider></el-divider>
    <goods-dialog ref="goodsDialog" in-dialog selectable @select="setGoods" />
  </div>
</template>
<script>
import goodsDialog from "@/components/sales/business/listDialog";
import accountSelect from "@/components/sales/business/select";
export default {
  props: {
    info: {},
  },
  components: {
    goodsDialog,
    accountSelect,
  },
  data() {
    return {
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      tableData: [],
      tableDel: [],
      sApi: require("@/api/sale/sales").default,
      api: require("@/api/stock/otherInDoc").default,
      account_api: require("@/api/goods/goods").default,
      stApi: require("@/api/stock/costBook").default,
      DAccount: [],
      initDAccount: [],
      initTotal: 0,
    };
  },
  mounted() {
    this.account_api
      .list({ Status: 1, pageIndex: 1, pageSize: 7 })
      .then((res) => {
        if (res.Code == 0)
          (this.DAccount = res.Data),
            (this.initDAccount = res.Data),
            (this.initTotal = res.Count);
      });
  },
  methods: {
    editT(row){
      row.T = row.T == 0 ? 0 : 1;
    },
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;
    },
    currentPage(val, row) {
      this.pageParams.pageIndex = val;
      let param = {
        Status: 1, 
        pageIndex: val, 
        pageSize: 7,
        GoodsName: row.GoodsName
      }
      this.account_api
        .list(param)
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;

            this.listTotal = res.Count;
          }
        });
    },
    inputText(text, row) {
      row.GoodsName = text;
      this.account_api
        .list({ Status: 1, pageIndex: 1, pageSize: 7, GoodsName: text })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;

            this.listTotal = res.Count;
          }
        });
    },
    onBlur(row, type) {
      if (row[type] == null) row[type] = 0;
    },
    onFocus(row, type) {
      if (row[type] == 0) row[type] = null;
    },
    // 非分页 千位符+保留后两位
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      const fieldNames = columns.map(col => col.property)
      fieldNames.forEach((field, index) => {
        if (field && ['Quantity1', 'NoTaxAmount', 'Quantity2', 'Quantity', 'CostPrice', 'TaxAmount', 'Amount', 'Offer'].includes(field)) {
          const values = data.map(item => Number(item[field]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + value
              } else {
                return prev
              }
            }, 0)
            // 数量字段，保留4位小数  
            if (['Quantity', 'Quantity1', 'Quantity2'].includes(field)) {
              sums[index] = Math.round(sums[index]*Math.pow(10,4))/Math.pow(10,4); 
            } else {
              sums[index] = sums[index].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
          } else {
            sums[index] = '/'
          }
        } else {
          sums[index] = ''
        }
      })
      sums[0] = '合计'
      return sums
    },
    rowClick(row) {
      if (!this.readonly) {
        var index = this.$refs.list.data.indexOf(row);
        if (index + 1 == this.$refs.list.data.length) {
          //
          this.addGoods();
        }
      }
    },
    async onSelect(e, row) {
      // this.setGoods(e,row)
      row.T = row.T == 0 ? 0 : 1;
      // row.AccountId = e.AccountId;
      // row.GoodsName = e.GoodsName;
      row.OrderGoodsId = 0;
      row.DocId = this.info.DocId || 0;
      row.BarCode = e.BarCode;
      row.GoodsCode = e.BarCode;
      row.GoodsName = e.GoodsName;
      row.GoodsId = e.GoodsId;
      row.Model = e.Model || "";
      row.UnitId = e.UnitId || 0;
      row.UnitName = e.MainUnitName || "";
      row.MainUnitName = e.MainUnitName || "";
      row.Quantity = 0;
      row.BatchNo = e.BatchNo || "";
      row.Offer = e.WholesalePrice || 0;
      row.Price = e.BalancePrice || 0;
      row.Discount = 100;
      row.ExistQuantity = e.ExistQuantity || 0;
      // row.AvailableQuantity = e.AvailableQuantity || 0;
      row.TaxRate = 0;
      row.TaxAmount = 0;
      row.Amount = 0;
      row.NoTaxAmount = 0;
      row.PromotionType = 0;
      row.PromotionId = 0;
      row.ReferenceCost = e.ReferenceCost || 0;
      row.GrossProfit = 0;
      row.Remark = e.Remark || "";
      row.Thumbnail = "";
      row.OutQuantity = 0;
      row.AddTime = this.info.DocDate || today;

      await this.account_api
      .getGoodsInventory(e.GoodsId, this.info.WarehouseId)
      .then((res) => {
        if(res.Data){
          row.ExistQuantity = res.Data.ExistQuantity ?? 0
        }else{
          row.ExistQuantity = 0
        }
        this.$emit('onSelect')
      });
    },
    getData() {
      if (this.info.DocId != 0 && this.tableData.length > 0) {
        this.tableData.forEach((item) => {
          if (item.T) {
            this.tableData.push(item);
          }
        });
      }
      this.tableData = [];
      this.tableData = this.info.Goods;
    },
    del(row, index) {
      this.$confirm("确认删除该行数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (!row.T && row.T !== 0) {
          row.T = 2;
          this.tableDel.push(row);
        }
        this.tableData.splice(index, 1);
      });
    },
    copy(row, index) {
      this.tableData.splice(index + 1, 0, {
        ...row,
        T: 0,
        DocGoodsId: 0,
      });
    },
    changeNum(row) {
      if (row.T !== 0) {
        row.T = 1;
      }
      // row.Quantity = Math.floor(row.Quantity)
      row.Amount = ((row.Quantity * row.Price) * 100 / 100).toFixed(2)
    },
    addGoods(e) {
      if (this.info.WarehouseId === null) {
        this.$message.warning("请先选择仓库");
        return;
      }
      let goods = {
        T: 0,
        OrderGoodsId: 0,
        DocId: 0,
        BarCode: "",
        GoodsCode: "",
        GoodsName: "",
        GoodsId: "",
        Model: "",
        UnitId: 0,
        UnitName: "",
        MainUnitName: "",
        Quantity: 0,
        BatchNo: "",
        Offer: 0,
        Discount: 100,
        Price: 0,
        ExistQuantity: 0,
        AvailableQuantity: 0,
        TaxRate: 0,
        TaxAmount: 0,
        Amount: 0,
        NoTaxAmount: 0,
        PromotionType: 0,
        PromotionId: 0,
        ReferenceCost: 0,
        GrossProfit: 0,
        Remark: "",
        Thumbnail: "",
        OutQuantity: 0,
        AddTime: "",
      };
      this.tableData.push(goods);
    },
    setGoods(e) {
      this.tableData.push({
        T: 0,
        DocGoodsId: 0,
        DocId: this.info.DocId,
        OrderGoodsId: e.OrderGoodsId || 0,
        BarCode: e.BarCode || "",
        GoodsCode: e.BarCode || "",
        GoodsId: e.GoodsId || 0,
        GoodsName: e.GoodsName || "",
        Model: e.Model || "",
        UnitId: e.MainUnitId || 0,
        UnitName: e.MainUnitName || "",
        MainUnitName: e.MainUnitName || "",
        Quantity: e.Quantity || 0,
        BatchNo: e.BatchNo || "",
        Offer: e.Offer || 0,
        Price: e.BalancePrice || 0,
        Amount: e.Amount || 0,
        Remark: e.Remark || "",
        Thumbnail: e.Thumbnail || "",
        AddTime: this.info.DocDate || "",
        AvailableQuantity: e.AvailableQuantity || 0,
      });
    },
  },
};
</script>

<style>
.el-link {
  font-size: 14px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>